import React from 'react';
import DeltaBadge from '../../Shared/DeltaBadge';
import { formatMoney, formatNumber } from '../../Shared/Formatters';

function Card({ side, label, value, txns, atv, cols, isWinner }) {
    return (
        <div className={`cmp-card${isWinner ? ' cmp-card-winner' : ''}`}>
            <div className="cmp-card-label" title={label}>{label}</div>
            <div className="cmp-card-value">{value != null ? formatMoney(value) : '—'}</div>
            <div className="cmp-card-meta">
                {txns != null && (
                    <span>{cols?.txns}: {formatNumber(txns, 0)}</span>
                )}
                {atv != null && (
                    <span>{cols?.atv}: {formatMoney(atv)}</span>
                )}
            </div>
        </div>
    );
}

/**
 * Two side-by-side cards for period/entity comparisons, with a delta chip
 * between them. Shape from blockBuilder: { a, b, delta_pct, winner, cols }.
 */
export default function ComparisonCards({ title, a, b, delta_pct, winner, cols }) {
    if (!a || !b) return null;
    return (
        <div className="chat-block">
            {title && <div className="chat-block-title">{title}</div>}
            <div className="cmp-cards">
                <Card side="a" {...a} cols={cols} isWinner={winner === 'a'} />
                <div className="cmp-delta">
                    {delta_pct != null
                        ? <DeltaBadge value={delta_pct} suffix="%" />
                        : <span className="cmp-vs">vs</span>}
                </div>
                <Card side="b" {...b} cols={cols} isWinner={winner === 'b'} />
            </div>
        </div>
    );
}
